import { createContext } from 'react';

const AdvancedPanelContext = createContext();

export default AdvancedPanelContext;
